/**
 * Utility functions for handling timezone display in the frontend.
 * Backend stores all timestamps in Eastern timezone for consistency.
 */

/**
 * Format a date string for display with timezone awareness.
 * Since backend stores in Eastern timezone, we can display as-is.
 * 
 * @param {string} dateString - Date string from backend (in Eastern timezone)
 * @param {Object} options - Formatting options for toLocaleString()
 * @returns {string} Formatted date string
 */
export const formatDateForDisplay = (dateString, options = {}) => {
    if (!dateString) {
        return '';
    }

    try {
        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return '';
        }

        const defaultOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };

        return date.toLocaleString(undefined, { ...defaultOptions, ...options });
    } catch (error) {
        console.error('Error formatting date:', error);
        return dateString; // Fallback to original string
    }
};
